import "whatwg-fetch"; // polyfill for older browsers
import {
  getAPIConfig,
  handleAPIResponse,
  convertQueryObjToString,
} from "@utils/browser-helpers";
import { executeAPIRequest } from "@adapters/api";

var sypiAdapter = {
  fetchSypiConfig: async (fetchConfig = {}, configCTID = "") => {
    let configRoute = `/sypi_s3_configs${fetchConfig ? `${convertQueryObjToString(fetchConfig)}` : ""
      }`; // TODO: ADD BACK &get_config_url=True`;
    const configApiConfig = getAPIConfig(configRoute);
    configApiConfig.url = configCTID
      ? configApiConfig.url.replace(localStorage.ctid, configCTID)
      : configApiConfig.url;
    const configResponse = await executeAPIRequest(configApiConfig, "GET");
    const configResponseData = await configResponse.json();
    /* TODO: ADD BACK LATER
     const handledConfig = handleAPIResponse(configResponseData);
    const publicUrlResponse = await fetch(handledConfig.public_url, {
      credentials: "include",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return `Error fetching data:, ${error}`;
      });

    return { sypi_config: publicUrlResponse };*/
    return handleAPIResponse(configResponseData);
  },
  fetchSypiConfigReleaseVersions: async (fetchConfig = {}, configCTID = "") => {
    let configRoute = `/sypi_s3_configs/list${fetchConfig ? `${convertQueryObjToString(fetchConfig)}` : ""
      }`;
    const configApiConfig = getAPIConfig(configRoute);
    configApiConfig.url = configCTID
      ? configApiConfig.url.replace(localStorage.ctid, configCTID)
      : configApiConfig.url;
    const configResponse = await executeAPIRequest(configApiConfig, "GET");
    const configResponseData = await configResponse.json();
    return handleAPIResponse(configResponseData);
  },
  updateSypiConfigReleaseVersions: async (configCTID = "", changes = {}) => {
    let configRoute = `/sypi_s3_configs/list`;
    const configApiConfig = getAPIConfig(configRoute);
    configApiConfig.url = configCTID
      ? configApiConfig.url.replace(localStorage.ctid, configCTID)
      : configApiConfig.url;
    const configResponse = await executeAPIRequest(
      configApiConfig,
      "PATCH",
      null,
      changes
    );
    const configResponseData = await configResponse.json();
    return handleAPIResponse(configResponseData);
  },
  fetchSypiSchema: async (fetchConfig = {}, schemaCTID = "") => {
    let schemaRoute = `/sypi_s3_configs/schema${fetchConfig ? `${convertQueryObjToString(fetchConfig)}` : ""
      }`;
    const schemaApiConfig = getAPIConfig(schemaRoute);
    schemaApiConfig.url =
      schemaCTID && localStorage.ctid
        ? schemaApiConfig.url.replace(localStorage.ctid, schemaCTID)
        : schemaCTID && !localStorage.ctid
          ? schemaApiConfig.url.replace("//", `/${schemaCTID}/`)
          : schemaApiConfig.url;
    const schemaResponse = await executeAPIRequest(schemaApiConfig, "GET");
    const schemaResponseData = await schemaResponse.json();
    return handleAPIResponse(schemaResponseData);
  },
  fetchSypiSchemaReleaseVersions: async (fetchConfig = {}, schemaCTID = "") => {
    let schemaRoute = `/sypi_s3_configs/schema/list${fetchConfig ? `${convertQueryObjToString(fetchConfig)}` : ""
      }`;
    const schemaApiConfig = getAPIConfig(schemaRoute);
    schemaApiConfig.url = schemaCTID
      ? schemaApiConfig.url.replace(localStorage.ctid, schemaCTID)
      : schemaApiConfig.url;
    const schemaResponse = await executeAPIRequest(schemaApiConfig, "GET");
    const schemaResponseData = await schemaResponse.json();
    return handleAPIResponse(schemaResponseData);
  },
  updateSypiSchema: async (changes = null) => {
    let updateSchemaRoute = `/sypi_s3_configs/schema`;
    const updateSchemaApiConfig = getAPIConfig(updateSchemaRoute);
    const updateSchemaResponse = await executeAPIRequest(
      updateSchemaApiConfig,
      "POST",
      null,
      changes
    );
    const updateSchemaResponseData = await updateSchemaResponse.json();
    return handleAPIResponse(updateSchemaResponseData, null, true);
  },
  updateSypiConfig: async (configChanges, fetchConfig = "") => {
    let configRoute = `/sypi_s3_configs${fetchConfig ? `/${fetchConfig}` : ""}`;
    const apiSypiConfig = getAPIConfig(configRoute);
    const configResponse = await executeAPIRequest(
      apiSypiConfig,
      "POST",
      null,
      configChanges
    );
    const configResponseData = await configResponse.json();
    return handleAPIResponse(configResponseData, null, true);
  },
  fetchSypiServerSettings: async () => {
    let route = `/sypi_server_configs`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  updateSypiServerSettings: async (changes) => {
    let route = `/sypi_server_configs`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "PATCH", null, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  fetchScheduledDraftList: async (scheduledDraf) => {
    let route = `/sypi_config_scheduler${scheduledDraf ? `${convertQueryObjToString(scheduledDraf)}` : ""
      }`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  fetchScheduledConfig: async (fetchConfig) => {
    let route = `/sypi_config_scheduler/scheduled${fetchConfig ? convertQueryObjToString(fetchConfig) : ""
      }`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  fetchDraftConfig: async (fetchConfig) => {
    let route = `/sypi_config_scheduler/draft${fetchConfig ? convertQueryObjToString(fetchConfig) : ""
      }`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  fetchHistoryConfig: async (fetchConfig) => {
    let route = `/sypi_config_scheduler/history${fetchConfig ? convertQueryObjToString(fetchConfig) : ""
      }`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  saveScheduledConfig: async (changes) => {
    let route = `/sypi_config_scheduler/scheduled`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "POST", null, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData, null, true);
  },
  saveDraftedConfig: async (changes) => {
    let route = `/sypi_config_scheduler/draft`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "POST", null, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData, null, true);
  },
  deleteScheduledConfig: async (fetchConfig) => {
    let route = `/sypi_config_scheduler/scheduled${fetchConfig ? convertQueryObjToString(fetchConfig) : ""
      }`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "DELETE");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  deleteDraftConfig: async (fetchConfig) => {
    let route = `/sypi_config_scheduler/draft${fetchConfig ? convertQueryObjToString(fetchConfig) : ""
      }`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "DELETE");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  deleteHistoryConfig: async (fetchConfig) => {
    let route = `/sypi_config_scheduler/history${fetchConfig ? convertQueryObjToString(fetchConfig) : ""
      }`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "DELETE");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  fetchSypiHistory: async (releaseVersion, versionId, configCTID = "") => {
    let configRoute = `/sypi_s3_configs/revert?release=${releaseVersion}&version_id=${versionId
      }`;
    const configApiConfig = getAPIConfig(configRoute);
    configApiConfig.url = configCTID
      ? configApiConfig.url.replace(localStorage.ctid, configCTID)
      : configApiConfig.url;
    const configResponse = await executeAPIRequest(configApiConfig, "GET");
    const configResponseData = await configResponse.json();
    return handleAPIResponse(configResponseData);
  },
  scheduleRevertConfig: async (changes) => {
    let route = `/sypi_config_scheduler/revert`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "POST", null, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData, null, true);
  },
};

window.sypiAdapter = sypiAdapter;

export default sypiAdapter;
